import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  isPicked: false,
  isPickedByDoubleClickInGridRow: false,
  data: null,
};

const odberatel = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_ODBERATEL_REQUEST:
    case actionTypes.UPDATE_ODBERATEL_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_ODBERATEL_SUCCESS:
      return { ...state, isLoading: false, data: action.res.Data };

    case actionTypes.UPDATE_ODBERATEL_SUCCESS:
    case actionTypes.UPDATE_ODBERATEL_FAILURE:
      return { ...state, isLoading: false };

    case actionTypes.GET_ODBERATEL_FAILURE:
      return _initState;

    case actionTypes.CHANGE_ODBERATEL:
      const { data, isPickedByDoubleClickInGridRow } = action;
      return {
        ...state,
        data,
        isLoading: false,
        isPickedByDoubleClickInGridRow,
        isPicked: data.I_ORGAN !== null,
      };

    default:
      return state;
  }
};

export default odberatel;
